import React, { Component } from "react";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import {
  GridRow,
  GridColumn,
  Img,
  Button,
  Toastr,
  Loader,
} from "arv-reactcomponents";

// import EmailSubscription from "./EmailSubscription";
import { isApp, getBaseRouteForPath } from "../../../utils";
import SizePrompt from "../../SizePrompt";
import Anchor from "../../../component/Anchor";
import FitGuidePrompt from "../../FitGuidePrompt";
import PriceBlock from "../../../component/ProductList/PriceBlock";
import ProductPromotions from "../../../component/ProductList/ProductPromotions";
import { HIDE_BRANDNAME, FAVORITESPAGE, Endpoints } from "npmlinks-constants";
import GTM from "../../../analytics/GTM";
import Event from "../../../analytics/eventFactory";
import Analytics from "../../../analytics";
import ProductTags from "../../ProductTags";

//
const DEFAULT_ADD_ITEM_COUNT = 1;

@inject("MybagStore", "WishListStore")
@observer
class FavoriteProduct extends Component {
  constructor() {
    super();
    this.state = {
      selectedSku: "",
      showSizePrompt: false,
      preventfix: false,
      showFitGuideModal: false,
      productLoading: false,
      errorImage: "",
    };
    this.showSizePromptFunc = this.showSizePromptFunc.bind(this);
    this.selectSkuAndAddToBag = this.selectSkuAndAddToBag.bind(this);
    this.closePrompt = this.closePrompt.bind(this);
    this.fitGuideModal = this.fitGuideModal.bind(this);
    this.closeFitGuideModal = this.closeFitGuideModal.bind(this);
    this.singleSkuCase = this.singleSkuCase.bind(this);
    this.singleSkuAndAddToBag = this.singleSkuAndAddToBag.bind(this);
    this.deleteProductFromFavorites = this.deleteProductFromFavorites.bind(
      this,
    );
    this.onImgError = this.onImgError.bind(this);
  }

  onImgError() {
    this.setState({
      errorImage: Endpoints.noImg,
    });
  }

  selectSku(sku) {
    Analytics.trackEvent({
      category: Event.category.FAVOURITES_PAGE,
      action: Event.action.SIZE_CHANGE,
      label: sku.skuId,
    });
    this.setState(state => {
      if (sku && !sku.qty) {
        sku.qty = DEFAULT_ADD_ITEM_COUNT; // eslint-disable-line
      }
      return {
        ...state,
        selectedSku: sku,
      };
    });
  }

  addToBag(event, sku) {
    if (event) {
      event.preventDefault();
    }
    const selectedSku = sku;
    const product = {
      skuId: selectedSku.skuId,
      qty: 1,
      sellableQty: selectedSku.sellableQuantity,
    };
    if (selectedSku && selectedSku.skuId) {
      this.setState({ productLoading: true });
      this.props.MybagStore.addToBag(product).then(res => {
        this.setState({ productLoading: false });
        this.deleteProductFromFavorites(true);
      });
      Analytics.trackEvent({
        action: Event.action.ADD_TO_BAG_SUCCESS,
        category: Event.category.FAVOURITES_PAGE,
      });
      GTM.pushWithEvent(
        {
          Id: selectedSku.skuId,
          brand: selectedSku.brandName,
          desc: selectedSku.name,
          mrp: selectedSku.mrp,
          dscnt: selectedSku.discountInPercentage,
          price: selectedSku.price,
          size: selectedSku.size,
          Qty: selectedSku.qty,
        },
        Event.GTMEvent.ADD_PRODUCT,
      );
    } else {
      this.setState({ showSizePrompt: true });
      Analytics.trackEvent({
        action: Event.action.ADD_TO_BAG_SIZE_PROMT,
        category: Event.category.FAVOURITES_PAGE,
      });
    }
    return null;
  }

  deleteProductFromFavorites(isAddingToBag) {
    this.setState({ productLoading: true });
    this.props.WishListStore.deleteFavProduct(this.props.product).then(res => {
      Analytics.trackEvent({
        action: Event.action.REMOVED,
        label: res.data.styleId,
        category: Event.category.FAVOURITES_PAGE,
      });
      if (!isAddingToBag)
        Toastr.showToastr({
          className: "nwc-toastr-list-success nw-toastr",
          message: FAVORITESPAGE.FAVORITES.PRODUCT_DELETED,
          timeout: 3000,
        });
      this.setState({ productLoading: false });
    });
  }

  selectSkuAndAddToBag(sku) {
    Analytics.trackEvent({
      action: Event.action.ADD_TO_BAG_SIZE_PROMPT_SELECTED,
      category: Event.category.FAVOURITES_PAGE,
    });
    this.selectSku(sku);
    this.addToBag(null, sku);
    this.closePrompt(true);
  }

  singleSkuAndAddToBag(sku) {
    Analytics.trackEvent({
      action: Event.action.ADD_TO_BAG_SIZE_PROMPT_SELECTED,
      category: Event.category.FAVOURITES_PAGE,
    });
    this.selectSku(sku);
    this.addToBag(null, sku);
  }
  closePrompt(postAddToBag) {
    this.setState({ showSizePrompt: false });
    if (postAddToBag !== true) {
      Analytics.trackEvent({
        action: Event.action.ADD_TO_BAG_SIZE_PROMPT_CLOSE,
        category: Event.category.FAVOURITES_PAGE,
      });
    }
    return null;
  }
  // eslint-disable-next-line class-methods-use-this
  singleSkuCase(skus) {
    let sizeArray = [];
    if (skus && skus.length > 0) {
      sizeArray = skus.map(sku => {
        const disabled = !sku.inStock || !sku.sellableQuantity > 0;
        if (!disabled) return sku;
      });
    }
    if (sizeArray && sizeArray.length === 1) {
      this.singleSkuAndAddToBag(sizeArray[0]);
      return true;
    }
    return false;
  }

  showSizePromptFunc(skus) {
    if (!this.singleSkuCase(skus)) this.setState({ showSizePrompt: true });
  }

  fitGuideModal(flag) {
    this.setState({ showFitGuideModal: true, preventfix: !!flag });
  }

  closeFitGuideModal() {
    this.setState({ showFitGuideModal: false, preventfix: false });
  }

  get productImage() {
    const { images } = this.props.product;

    return this.state.errorImage || images.url || Endpoints.noImg;
  }

  render() {
    const { product } = this.props;
    const {
      name,
      brandName,
      skus,
      mrpRange,
      discountRange,
      sellingPriceRange,
      primaryColor,
      sizeChartId,
      promotions,
      inStock,
      url,
      productTags,
      sku,
      size,
    } = product;


    const {
      showSizePrompt,
      showFitGuideModal,
      preventfix,
      productLoading,
    } = this.state;
    const ProductLoader = false;
    return (
      <GridColumn className="nw-favoriteproduct nwc-grid-col-md">
        <GridRow className="nw-favoriteproduct-row">
          <GridColumn className="nw-favoriteproduct-image nwc-grid-col-md-5 nwc-grid-col-xs-5">
            <div className={`nw-favoriteproduct-imgcontainer ${!inStock}`}>
              <Anchor.component to={url} href={url}>
                <Img
                  className="nw-favoriteproduct-img"
                  src={this.productImage}
                  onError={this.onImgError}
                />
              </Anchor.component>
              <div className="nw-favoriteproduct-outofstock ">
                <div className="nw-favoriteproduct-oosoverlay" />
                <span className="nw-favoriteproduct-oostext">
                  {FAVORITESPAGE.FAVORITES.OUT_OF_STOCK}
                </span>
              </div>
            </div>
          </GridColumn>
          <GridColumn className="nw-favoriteproduct-col nwc-grid-col-md-7 nwc-grid-col-xs-7">
            {productLoading && (
              <div className="nw-checkoutpage-initialloader nw-favoritepage-loader nwc-translucentbackground-white">
                <Loader />
              </div>
            )}
            <div className="nw-favoriteproduct-container">
              <div className="">
                <ProductTags.component
                  tagData={productTags}
                  className="nw-favoriteproduct-producttag"
                />
                <h3 className="nw-favoriteproduct-brandtxt">{brandName}</h3>
                <Anchor.component to={url} href={url}>
                  <div className="nw-favoriteproduct-titletxt">
                    <p className="nw-favoriteproduct-title">{name}</p>
                  </div>
                </Anchor.component>
              </div>
              <div className="nw-favoriteproduct-color">
                <span>
                  {FAVORITESPAGE.FAVORITES.COLOR_LABEL}: { typeof size === 'undefined' ? `${primaryColor}`:`${primaryColor} | ${size}`}
                </span>
              </div>
              <PriceBlock.component
                discountRange={discountRange}
                mrpRange={mrpRange}
                sellingPriceRange={sellingPriceRange}
                className="nw-product-price nw-favoriteproduct-price"
              />
              <div className="nw-favoriteproduct-promo">
                <ProductPromotions.component
                  className="nw-favoriteproduct-promotions"
                  promotions={promotions}
                />
              </div>
              <div className="nw-favoriteproduct-actions">
                <Button
                  className="nw-favoriteproduct-action nw-favoriteproduct-addtobag"
                  onClick={() => typeof size === 'undefined' ? this.showSizePromptFunc(skus) : this.selectSkuAndAddToBag(sku) }
                  disabled={!inStock}
                >
                  {FAVORITESPAGE.FAVORITES.CTAS.MOVE_TO_BAG}
                </Button>
                {/* <Button
                  className="nw-favoriteproduct-action nw-favoriteproduct-share"
                  disabled={!inStock}
                >
                  {FAVORITESPAGE.FAVORITES.CTAS.SHARE}
                </Button> */}
                <Button
                  className="nw-favoriteproduct-action nw-favoriteproduct-remove"
                  onClick={() => this.deleteProductFromFavorites()}
                >
                  {FAVORITESPAGE.FAVORITES.CTAS.REMOVE}
                </Button>
              </div>
              <SizePrompt.component
                className="nw-favoriteproduct-sizeblock"
                selectSku={this.selectSkuAndAddToBag}
                skus={skus}
                ProductLoader={ProductLoader}
                showSizePrompt={showSizePrompt}
                closePrompt={this.closePrompt}
                fitGuideModal={this.fitGuideModal}
                sizeChartId={sizeChartId}
              />
              <FitGuidePrompt.component
                brandName={brandName}
                productTitle={name}
                sizeChartId={sizeChartId}
                showFitGuideModal={showFitGuideModal}
                preventfix={preventfix}
                closeFitGuideModal={this.closeFitGuideModal}
              />
            </div>
          </GridColumn>
        </GridRow>
      </GridColumn>
    );
  }
}

FavoriteProduct.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string.isRequired,
    brandName: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    ).isRequired,
    skus: PropTypes.arrayOf(
      PropTypes.shape({
        skuId: PropTypes.string.isRequired,
        size: PropTypes.string.isRequired,
        inStock: PropTypes.bool.isRequired,
        sellableQuantity: PropTypes.number.isRequired,
      }),
    ).isRequired,
    mrpRange: PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
    }).isRequired,
    discountRange: PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
    }).isRequired,
    sellingPriceRange: PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
    }).isRequired,
    primaryColor: PropTypes.string.isRequired,
    sizeChartId: PropTypes.string.isRequired,
    promotions: PropTypes.arrayOf(PropTypes.shape({})),
    productTags: PropTypes.arrayOf(
      PropTypes.shape({
        tagUrl: PropTypes.string,
        tagText: PropTypes.string,
        tagTextColor: PropTypes.string,
      }),
    ),
  }).isRequired,
};

FavoriteProduct.wrappedComponent.propTypes = {
  MybagStore: PropTypes.shape({
    addToBag: PropTypes.func.isRequired,
  }).isRequired,
  WishListStore: PropTypes.shape({
    deleteFavProduct: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: FavoriteProduct,
  component: FavoriteProduct,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Favorites/FavoriteProduct/index.js